import { render, staticRenderFns } from "./BotClient.vue?vue&type=template&id=05514e00&scoped=true&"
import script from "./BotClient.vue?vue&type=script&lang=js&"
export * from "./BotClient.vue?vue&type=script&lang=js&"
import style0 from "./BotClient.vue?vue&type=style&index=0&id=05514e00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05514e00",
  null
  
)

export default component.exports